export const tumblrAccountBlogURLRegExp =
  /(?:(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?tumblr?[^:/\n?]+\/blog\/|@|)([^\s/?#]+)\/?$/;
